(function ($) {
	function filterNews() {
		let searchValue = $("#filter-news-search").val();
		const postName = $("#filter-news-post-type").val();

		jQuery.ajax({
			url: PHP_VARS.ajax_url,
			type: "POST",
			data: {
				action: "news_filter_posts",
				search_value: searchValue,
				post_name: postName,
			},
			success: function (response) {
				if (response.success) {
					$(".news-posts").html(response.data);

					$(".news-card").hide().slice(0, 10).show();

					if ($(".news-card").length > 10) {
						$(".load_posts").show();
					} else {
						$(".load_posts").hide();
					}
				} else {
					console.log(response);
					$(".news-posts").html("<h1>No results found.</h1>");
				}
			},
		});
	}

	$(".filter-news-submit").on("click", function (e) {
		e.preventDefault();
		filterNews();
	});

	$("#filter-news-search").on("keydown", function (e) {
		if (e.key === "Enter" || e.keyCode === 13) {
			e.preventDefault();
			filterNews();
		}
	});

	$("#filter-news-search").on("input", function () {
		if ($(this).val().trim() === "") {
			filterNews();
		}
	});
})(jQuery);
